import axios from "axios";
import { useMutation } from "react-query";

const API_PATH = "customerexclusivelist";

export const useAssignList = () =>
  useMutation((data: { customerAccountId: string; exclusiveListId: string }) =>
    axios
      .post(`${API_PATH}/assign`, data)
      .then((res) => res.data)
      .catch((reason) => Promise.reject(reason.response))
  );

export const useToggleAssignment = () =>
  useMutation((data: { id: string; isActive: boolean }) =>
    axios
      .post(`${API_PATH}/toggle`, data)
      .then((res) => res.data)
      .catch((reason) => Promise.reject(reason.response))
  );

export const useDeleteAssignment = () =>
  useMutation((id: string) =>
    axios
      .post(`${API_PATH}/delete`, { id })
      .then((res) => res.data)
      .catch((reason) => Promise.reject(reason.response))
  );
